import { IPdfBrickOptions, PdfBrick } from './pdf_brick';
import { IRect, DocController } from '../doc_controller';
import { ITextStyle } from '../style/types';

export interface IHTMLOptions extends IPdfBrickOptions {
    html: string;
}

export class HTMLBrick extends PdfBrick {
    public constructor(controller: DocController,
        rect: IRect, protected options: IHTMLOptions, protected style: ITextStyle) {
        super(controller, rect);
    }
    public async renderInteractive(): Promise<void> {
        this.controller.setTextStyle(this.style);
        await new Promise<void>((resolve) => {
            this.controller.doc.fromHTML(this.options.html, this.contentRect.xLeft, this.contentRect.yTop, {
                width: this.contentRect.width, pagesplit: true,
            }, function () {
                [].slice.call(document.querySelectorAll('.sjs-pdf-hidden-html-div')).forEach(
                    function (el: HTMLDivElement) {
                        el.parentNode.removeChild(el);
                    }
                );
                resolve();
            }, {
                top: this.controller.margins.top,
                bottom: this.controller.margins.bot
            });
        });
        this.controller.restoreTextStyle();
    }
}